
import { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { jaJP } from '@mui/x-data-grid'
import { addDays, format } from 'date-fns'
import { Button } from '@mui/material'
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown'
import { usePost } from './../../apis/ApiRequests'
import { useAuth } from '../../contexts/AuthContext'
import { dateToString } from '../../utils/Library'
import Header from '../../components/Header'
import Frame from '../../components/uiParts/Frame'
import TitleBar from '../../components/uiParts/TitleBar'
import { CustomDataGrid } from '../../components/dataGrid/CustomDataGrid'
import BidSearchForm from '../../components/uiParts/bid/BidSearchForm'
import CustomCheckbox from '../../components/input/CustomCheckbox'
import CustomSnackBar from '../../components/alert/CustomSnackBar'
import CustomConfirm from '../../components/confirm/CustomConfirm'
import Encoding from 'encoding-japanese'


const TransferList = () => {

    //===============================================
    // initialize
    //===============================================
    //-----------------------------------------------
    // initialize - セッション情報を取得
    //-----------------------------------------------
    const { authInfo }   = useAuth()
    const facilityCode   = authInfo.facilityCode
    const facilityName   = authInfo.facilityName
    const userId         = authInfo.userId
    const luserName      = authInfo.userName
    const authority      = authInfo.authority
    const today          = format(addDays(new Date(), 0), 'yyyy-MM-dd')
    const navigate       = useNavigate()
    
    const search    = useLocation().search
    const query     = new URLSearchParams(search)
    const targetDate  = query.get("targetDate") || today
    const checkStatus  = query.get("checkStatus") || 1

    //-----------------------------------------------
    // initialize - useState
    //-----------------------------------------------
    const [ entryDate,             setEntryDate             ] = useState(targetDate)
    const [ condition ,            setCondition             ] = useState('')
    const [ searchStatus ,         setSearchStatus          ] = useState(checkStatus)
    const [ searchCount,           setSearchCount           ] = useState(0)
    const [ dataGridHeight,        setDataGridHeight        ] = useState(window.innerHeight - 210)
    const [ checkedBidList,        setCheckedBidList        ] = useState([])
    const [ dataInputList,         setDataInputList         ] = useState([])
    const [ checkedDataInputList,  setCheckedDataInputList  ] = useState([])
    
    // UI Message
    const [ messageState, setMessageState ] = useState({
        snackBarTrue  : false,
        snackBarFalse : false,
        require       : false,
        confirm       : false,
        confirm       : false,
    })
    //===============================================
    // API
    //===============================================
    //-----------------------------------------------
    // API - searchDataByDataInput / BidGroup
    //-----------------------------------------------
    const { response : searchData_res, loading : searchData_Loading, post:searchData_post } = usePost()
    const searchData = async () => {
        const numericDate = dateToString(entryDate)
        const postData = {
            'className'    : 'mch.models.table.Transaction',
            'methodName'   : 'searchDataByTransfer',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'keyword1'     : numericDate,
            'keyword2'     : condition,
            'keyword3'     : searchStatus,
        }
        await searchData_post(postData)
    }
	//-----------------------------------------------
    // API - exportBidList / file_transfer
	//-----------------------------------------------
    const { response : exportBidList_res, post : exportBidList_post } = usePost()
    const exportBidList = async () => {
        const targetDate = dateToString(entryDate)
        const postData = {
            'className'    : 'mch.models.file.Transfer',
            'methodName'   : 'exportBidList',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'targetDate'   : targetDate,
            'targetList'   : checkedDataInputList,
        }
        await exportBidList_post(postData)
    }
    //===============================================
    // useEffect
    //===============================================
    //-----------------------------------------------
    // useEffect - ロード時の設定
    //-----------------------------------------------
    useEffect(() => {

        setSearchCount(searchCount+1)
        
        const handleResize = () => {
            setDataGridHeight(window.innerHeight - 210)
        }
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
        
    },[])
    //-----------------------------------------------
    // useEffect - 検索処理
    //-----------------------------------------------
    useEffect(() => {
        searchData()
    }, [searchCount])
    //-----------------------------------------------
    // useEffect - APIレスポンス(searchDataByDataInput / bidGroup)
    //-----------------------------------------------
    useEffect(() => {
        setDataInputList([])
        if (searchData_res) {
            setDataInputList(searchData_res.Data)
        }
    }, [searchData_res])
    useEffect(() => {
        if (dataInputList) {
            // bidStatusが1の行のIDを集める
            const selectedRows = dataInputList.filter(row => row.checkStatus === 1).map(row => row.id);
            setCheckedDataInputList(selectedRows);
        }
    }, [dataInputList]);
	//-----------------------------------------------
    // useEffect - exportBidList / file_transfer
	//-----------------------------------------------
    useEffect(() => {
        if (exportBidList_res) {
            let textData = exportBidList_res.text

            // 改行コードを \r\n に統一（Windows形式）
            textData = textData.replace(/\r?\n/g, '\r\n')

            // Shift_JIS（SJIS）エンコード
            const unicodeArray = Encoding.stringToCode(textData)
            const sjisArray = Encoding.convert(unicodeArray, {
                to: 'SJIS',
                from: 'UNICODE',
                type: 'array',
            })

            const sjisBlob = new Blob([new Uint8Array(sjisArray)], {
                type: 'text/csv',
            })

            const blobUrl = URL.createObjectURL(sjisBlob)
            const hiddenElement = document.createElement('a')
            hiddenElement.href = blobUrl
            hiddenElement.target = '_blank'
            hiddenElement.download = 'SERIDATA.CSV'
            hiddenElement.click()
            setMessageInfo('confirm', false)
            setMessageInfo('snackBarTrue', true)

            setSearchCount(searchCount+1)
        }
    }, [exportBidList_res])

    //===============================================
    // eventHandler
    //===============================================
    //-----------------------------------------------
    // eventHandler - 検索ボタン
    //-----------------------------------------------
    const handleClick_search = () => {
        setSearchCount(searchCount+1)
    }
    //-----------------------------------------------
    // eventHandler - 検索クリアボタン
    //-----------------------------------------------
    const handleClick_search_clear = () => {
        setEntryDate(today)
        setCondition('')
        setSearchStatus(1)
        setSearchCount(searchCount+1)
    }
	//-----------------------------------------------
	// eventHandler - 検索Statusの変更
	//-----------------------------------------------
    const handleChange_searchStatus = (checked) => {
        checked ? setSearchStatus(1) : setSearchStatus('')
        setSearchCount(searchCount+1)
    }
    //===============================================
    // dataGrid
    //===============================================
    //-----------------------------------------------
    // dataGrid - テーブルの見出し
    //-----------------------------------------------
    const columnsxBidGroup = [
        { field: 'correctDate', headerName: '補正登録日',   width: 110, columnSeparatorWidth: 1, sortable:false,},
        { field: 'entryDate', headerName: '入札日',   width: 110, columnSeparatorWidth: 1, sortable:false,},
        { field: 'reportNo',      headerName: '浜帳No', width: 100, columnSeparatorWidth: 1, align:'right', },
        { field: 'senmei',   headerName: '荷主',   width: 180, columnSeparatorWidth: 1, sortable:false, },
        { field: 'displayGyoshu', headerName: '品名',   width: 450, columnSeparatorWidth: 1, sortable:false,},
    ]
    const statusMapping = {
        0: '未チェック',
        1: 'チェック完了',
        9: '連携済み',
    }
    //-----------------------------------------------
    // dataGrid - 行の選択
    //-----------------------------------------------
    const handleClick_dataInputList = (event) => {
        if (event.field === '__check__') {
            if (checkedDataInputList.includes(event.id)) {
                setCheckedDataInputList(checkedDataInputList.filter((checkedDataInputList, index) => (checkedDataInputList !== event.id)));
            } else {
                setCheckedDataInputList((checkedDataInputList)=>[...checkedDataInputList, event.id]);
            }
        }
    }
    const generateTransfer = () => {
        exportBidList()
    }
    //===============================================
    // Function
    //===============================================
	//===============================================
	// UI Message
	//===============================================
    const setMessageInfo = (target, state) => {
        setMessageState(prevSearchData => ({
            ...prevSearchData,
            [target]: state,
        }))
    }
    //===============================================
    // Css
    //===============================================
    
    //===============================================
    // JSXのレンダー
    //===============================================
    return (
        <>
            <Header loginInfo="on" backButton="on" backPage="/home" />
            <div className='dataInput bodyContens'>
                <TitleBar title="販売管理CSV作成" />
                <div className='mainContents'>
                    <Frame classname="frame" title="連携データ検索">
                        <div style={{display:'flex'}}>
                            <div> 
                                <BidSearchForm
                                    targetDateId       = "dataInput_targetDate"
                                    targetDateValue    = { entryDate }
                                    targetDateOnChange = { (e) => setEntryDate(e.target.value) }
                                    keywordId          = "dataInput_condition"
                                    keywordValue       = { condition }
                                    keywordOnChange    = { (e) => setCondition(e.target.value) }
                                    handleSearch       = { () => handleClick_search() }
                                    handleSearchClear  = { () => handleClick_search_clear() }
                                />
                            </div>
                            <div style={{marginLeft:'20px'}}>
                                <CustomCheckbox
                                    defaultChecked = { searchStatus == 0 ? false : true }
                                    onChange       = { (e) => handleChange_searchStatus(e.target.checked) }
                                    label          = "未連携を表示"
                                />
                            </div>
                                <div style={{marginBottom:'8px', marginLeft:'10px'}}>
                                    <Button
                                        color     = "primary"
                                        style     = {{color:'#fff', }}
                                        size      = "midium"
                                        variant   = "contained"
                                        startIcon = {<ArrowCircleDownIcon />}
                                        onClick   = {() => setMessageInfo('confirm', true) }
                                    >
                                    ダウンロード
                                    </Button>
                                </div>
                        </div>
                        <div style={{marginTop:'10px'}}>
                            <CustomDataGrid
                                getRowClassName={(params) =>
                                    params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                                }
                                editMode                = "row"
                                disableSelectionOnClick = { true } 
                                rows                    = { dataInputList }
                                columns                 = { columnsxBidGroup }
                                sx                      = { {height:dataGridHeight,fontSize:14,borderColor: 'primary.light',} }
                                density                 = "compact"
                                localeText              = { jaJP.components.MuiDataGrid.defaultProps.localeText }
                                showColumnRightBorder
                                showCellRightBorder
                                checkboxSelection
                                disableColumnMenu          = {true}
                                onCellClick                = {(event) => handleClick_dataInputList(event)}
                                onRowSelectionModelChange  = {(newSelectionModel) => { setCheckedDataInputList(newSelectionModel) }}
                                rowSelectionModel          = {checkedDataInputList}
                                loading = { searchData_Loading }

                            />
                        </div>
                    </Frame>
                </div>
                <CustomSnackBar
                    open            = {messageState.snackBarTrue}
                    onClose         = {() => setMessageInfo('snackBarTrue', false)}
                    severity        = "success"
                    backgroundColor = "#2e8b57"
                    message         = "ファイル出力が完了しました"
                />
                <CustomConfirm
                    open      = {messageState.confirm}
                    onClose   = {() => setMessageInfo('confirm', false)}
                    onClickNG = {() => setMessageInfo('confirm', false)}
                    onClickOK = {() => generateTransfer()}
                    message   = {'連携用CSVファイルを出力します。よろしいですか？'}
                />
            </div>
        </>
    )
}
export default TransferList
